// El nivel del wizard traducido al que pinta la píldora compartida: son dos catálogos gemelos
// —`ClientLevel` local y `ClientLevelEnum` del type-kit— y solo el del type-kit lleva color.
import { ClientLevelEnum } from '@fiado/type-kit/bin/loanScoring/enums/ClientLevelEnum';
import type { TierValue } from '@/shared/patterns/Pills';
import type { ClientLevel } from './types';

const TIER_BY_CLIENT_LEVEL: Record<ClientLevel, ClientLevelEnum> = {
    NOT_ELIGIBLE: ClientLevelEnum.NOT_ELIGIBLE,
    BRONZE: ClientLevelEnum.BRONZE,
    SILVER: ClientLevelEnum.SILVER,
    GOLD: ClientLevelEnum.GOLD,
};

/** Sin nivel devuelve `null`: la píldora lo dice con palabras en vez de desaparecer. */
export function toTierValue(level: ClientLevel | undefined): TierValue {
    return level === undefined ? null : TIER_BY_CLIENT_LEVEL[level];
}
